import { createFileRoute, redirect } from '@tanstack/react-router';

import { FeatureFlagsAdmin } from '../modules/FeatureFlags';
import { canOpenFeatureFlags } from '../modules/FeatureFlags/utils';

export const Route = createFileRoute('/admin/feature-flags')({
  component: RouteComponent,
  // FeatureFlagAdmin, or the owner of at least one flag (read from ListFlags through the router
  // context). This only hides the page: the backend checks every write again.
  //
  // Known edge: FeatureFlagProvider stops waiting for ListFlags after three seconds and renders
  // with no rows, so an owner without FeatureFlagAdmin who deep-links here while the read is
  // still slow is sent home, and the nav entry appears once the read lands. Admins are unaffected.
  loader(ctx) {
    const { authContext, featureFlags } = ctx.context;
    if (!canOpenFeatureFlags(authContext.user, featureFlags.rows)) {
      throw redirect({ to: '/' });
    }
  },
  head() {
    return {
      meta: [{ title: 'Feature Flags' }],
    };
  },
});

function RouteComponent() {
  return <FeatureFlagsAdmin />;
}
